import { Injectable } from '@angular/core';
import { rdsapControlsHeatersPdcbData994 } from 'src/rdsap/config/rdsap-controls-heaters-pdcb-data.config';

@Injectable({
  providedIn: 'root'
})
export class PcdfSearchManual371Service {

  private pcdbControlsHeatersData = rdsapControlsHeatersPdcbData994;

  viewPcdbControlsHeatersData(): any[] {
    return this.pcdbControlsHeatersData.data[371].filter(item => {
      if(item.status === '0' && (item.controllerType === '2' || item.controllerType === '3')) { return item; }
    })
  }

  viewPcdbWeatherCompensationData(): any[] {
    return this.pcdbControlsHeatersData.data[371].filter(item => {
      if(item.status === '0' && (item.controllerType === '1' || item.controllerType === '3')) { return item; }
    })
  }
}
